import { render } from "./event_register_edit.vue?vue&type=template&id=b8fd8f32&scoped=true"
import script from "./event_register_edit.vue?vue&type=script&lang=js"
export * from "./event_register_edit.vue?vue&type=script&lang=js"

import "./event_register_edit.vue?vue&type=style&index=0&id=b8fd8f32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8fd8f32"]])

export default __exports__